<template>
    <div class="field__calendar">
        <date-picker
            v-model="range"
            is-range
            value=""
            color="blue"
            locale="pt"
            is-expanded
            :masks="mask"
            @input="action( $event )"
            v-bind="{
                ...( configs.mode && { mode: configs.mode }),
                ...( configs.minDate && { 'min-date': configs.minDate }),
                ...( configs.maxDate && { 'max-date': configs.maxDate }),
                ...( configs.is24hr && { is24hr: configs.is24hr, 'minute-increment': 5 })
            }"
        >
        <template v-if="!configs.hideInput" v-slot="{ inputEvents }">
          <div class="flex flex-col sm:flex-row justify-start items-center">
            <div class="relative flex-grow">
            </div>
            <div class="relative flex-grow">
              <input
                :id="name"
                class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                :class="targetClass"
                :value="`${textStart} - ${textEnd}`"
                v-on="inputEvents.end"
              />
            </div>
          </div>
        </template>
        </date-picker>
    </div>
</template>

<script>
// packages
import {
    ref,
    reactive,
    toRefs
} from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

// componentes
import { DatePicker, Locale } from 'v-calendar';

// utils
import { haveProperty } from '@/utils/';

// store
import { useActions } from '@/hooks/use-store';

// definições das datas.
const locale = new Locale();
const defaultFormat = 'DD-MM-YYYY';

export default {
    inheritAttrs: false,
    components: {
        DatePicker
    },
    props: {
        targetClass: String,
        reset: Boolean,
        defaultValue: Array,
        searchField: Boolean,
        name: String,
        configs: {
            type: Object,
            default: () => ({})
        }
    },
    setup ( props, { emit }) {
        const dateString = ref( props.defaultValue );
        const format = props.configs?.format || defaultFormat;
        const mask = { input: format };

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({
            props,
            object: dateString,
            key: 'value'
        });

        /**
         * Formatação da data.
         *
         * @param {String/Date} date
         * @param {String} type - parse / formate
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const formatDate = ( date, type ) => locale[type]( date, format );

        const range = reactive({
            start: '',
            end: ''
        });

        // alterar o texto da input
        const inputText = reactive({
            textStart: '',
            textEnd: ''
        });

        if ( props.searchField && props.defaultValue ) {
            [ range.start, range.end ] = props.defaultValue;

            inputText.textStart = range.start || '';
            inputText.textEnd = range.end || '';
        }

        // emite o valor para o compomente pai.
        const { actions } = useActions();

        const action = input => {
            range.start = formatDate( input.start, 'format' );
            range.end = formatDate( input.end, 'format' );

            inputText.textStart = formatDate( input.start, 'format' );
            inputText.textEnd = formatDate( input.end, 'format' );

            if ( props.searchField )
                actions( 'saveSearchData', { [props.name]: [ range.start, range.end ] });
            else {
                emit( 'input', {
                    fromDate: range.start,
                    toDate: range.end
                });
            }
        };

        return {
            mask,
            action,
            haveProperty,
            ...toRefs( range ),
            ...toRefs( inputText ),
            range,
            formatDate
        };
    }
};
</script>